import React from 'react'

import { Checkbox } from '@fourthwall/components'

import { TableCell } from '../../../../../../../components/common/TableCell'
import type { Series } from '../../../../types'
import { SeriesCell } from '../../../Series/components/SeriesCell'
import type { Props } from './types'

export const getTableHeaders = (
  selectedSeries: Props['selectedSeries'],
  onSelect: (singleSeries: Series) => (value: boolean) => void,
) => {
  return [
    {
      id: 'select',
      label: '',
      render: (singleSeries: Series) => {
        const input = (
          <Checkbox
            value={
              !!selectedSeries?.find(
                (selectedSingleSeries) => selectedSingleSeries.id === singleSeries.id,
              )
            }
            onValueChange={onSelect(singleSeries)}
          />
        )

        return <TableCell mainContent={input} />
      },
      width: 0.5,
    },
    {
      id: 'name',
      label: '',
      render: (singleSeries: Series) => (
        <SeriesCell
          title={singleSeries.title}
          quantity={singleSeries.episodesCount}
          thumbnailUrl={singleSeries.coverImage?.url}
        />
      ),
      width: 12,
    },
  ]
}
